const PLACEHOLDER_REGEX = /\[([^\]]+)\]/g;

/**
 * Оборачивает все плейсхолдеры вида [text] в тег <mark>
 * @param text - Исходный текст (может содержать markdown-разметку)
 * @returns Текст с обернутыми в <mark> плейсхолдерами
 */
export function wrapPlaceholdersWithMark(text: string): string {
    return text.replace(PLACEHOLDER_REGEX, '<mark>$&</mark>');
}
